import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { fetchUserById } from "../../store/user-slice"; // Adjust to your actual action import
import { useDispatch, useSelector } from "react-redux";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Detail from "../../components/common/detail/Detail";
import { getDetailData } from "../../models/userModel";
import {getValidatedLimit} from "../../components/Utility"; // Adjust to your actual model import

const UserDetails = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.user);
    const {limit, currentPage} = getValidatedLimit(pagination);


    useEffect(() => {
        dispatch(fetchUserById(params.userId)); // Adjust based on your actual Redux action
    }, [dispatch, params.userId]);

    const {
        items: users,
        fetchByIdStatus,
        error
    } = useSelector(state => state.user); // Adjust based on your Redux slice
    const user = users.find(user => user.id === params.userId); // Ensure correct id matching
    const detailData = getDetailData({ item: user }); // Adjust this to fit how you process data for details

    return (
        <>
            <SubHeader title="User Details">
                <Button to={`../?page=${currentPage}&limit=${limit}`} className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                {fetchByIdStatus === "loading" && <p>Loading...</p>}
                {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchByIdStatus === "success" && <Detail inline={true} columns={{ lg: 9, xl: 7 }} data={detailData} />}
            </div>
        </>
    );
};

export default UserDetails;
